import { useUser } from './useUser';
import { useAuthStore } from '../store/auth.store';
/**
 * The unified authentication hook (Facade).
 *
 * This hook provides a single, consistent interface for core authentication state,
 * abstracting session and user data fetching. It uses `useAuthStore` for the
 * client-side auth status and `useUser` for server-side user data.
 *
 * @returns A comprehensive object with auth state and methods.
 */
export const useAuth = () => {
    // --- State Hooks ---
    // Get session and status directly from the global store
    const { session, status, isInitialized } = useAuthStore(state => ({
        session: state.session,
        status: state.status,
        isInitialized: state.isInitialized,
    }));
    // Get user data from React Query. This hook is now aware of the auth status
    // and will only fetch when appropriate.
    const { data: user, isError, error } = useUser();
    // --- Derived State ---
    const isAuthenticated = status === 'authenticated';
    const isLoading = status === 'pending' || !isInitialized;
    const isPasswordRecovery = status === 'password_recovery';
    return {
        // State
        user,
        session,
        status,
        isAuthenticated,
        isLoading, // Combines pending status with initialization status
        isInitialized,
        isPasswordRecovery,
        isError,
        error,
    };
};
//# sourceMappingURL=useAuth.js.map